import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import {
    ClosureFilterDTO,
    DashboardClosureResponseDTO
} from 'pages/FinancialManagement/components/Closure/types'
import {
    FinanceDashboardResponseDTO,
    FinanceFilterDTO
} from 'pages/FinancialManagement/components/Finance/types'
import api from './api'

const { ENDPOINT_REPORT_CSV } = environments

export const getFinanceDashboardData = async (
    filter: FinanceFilterDTO,
    IF?: string
): Promise<AxiosResponse<FinanceDashboardResponseDTO>> => {
    return api.get(
        `${ENDPOINT_REPORT_CSV}/graficos/operacoes/financeiro?${new URLSearchParams(
            Object.assign({ ...filter, instituicaoFinanceira: IF ?? '' })
        )}`
    )
}

interface ClosureDashboardParams extends ClosureFilterDTO {
    cnpjAgente: string
}

export const getClosureDashboards = async (
    params: ClosureDashboardParams,
    IF?: string
): Promise<AxiosResponse<DashboardClosureResponseDTO>> => {
    return api.get(
        `${ENDPOINT_REPORT_CSV}/graficos/operacoes/financeiro-sintetico?${new URLSearchParams(
            Object.assign({ ...params, instituicaoFinanceira: IF ?? '' })
        )}`
    )
}
